import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FAQSchema from "@/components/schema/FAQSchema";
import KOHeroSection from "@/components/keyword-optimisation/KOHeroSection";
import KOProblemSection from "@/components/keyword-optimisation/KOProblemSection";
import KOBudgetAnalysis from "@/components/keyword-optimisation/KOBudgetAnalysis";
import KOAffordabilityFilter from "@/components/keyword-optimisation/KOAffordabilityFilter";
import KOVolumeSorting from "@/components/keyword-optimisation/KOVolumeSorting";
import KOThematicGrouping from "@/components/keyword-optimisation/KOThematicGrouping";
import KOCampaignReady from "@/components/keyword-optimisation/KOCampaignReady";
import KOResultsSection from "@/components/keyword-optimisation/KOResultsSection";
import KOComparisonSection from "@/components/keyword-optimisation/KOComparisonSection";
import KOFAQSection from "@/components/keyword-optimisation/KOFAQSection";
import KOFinalCTA from "@/components/keyword-optimisation/KOFinalCTA";
import { faqItems } from "@/components/keyword-optimisation/mockData";

const KeywordOptimisation = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Keyword Optimisation | Budget-Smart Google Ads Keywords | Upfixe</title>
        <meta
          name="description"
          content="Stop wasting your Google Ads budget on keywords you can't afford. Upfixe's budget-smart keyword optimisation filters by CPA, prioritises by search volume, and organises into thematic ad groups for maximum ROI."
        />
        <meta
          name="keywords"
          content="keyword optimisation, google ads keyword strategy, budget-based keyword selection, affordable google ads keywords, keyword bid optimisation, ad group organisation, google ads budget optimisation, CPA keyword filtering, search volume prioritisation, thematic ad groups"
        />
        <meta
          property="og:title"
          content="Keyword Optimisation | Budget-Smart Google Ads Keywords | Upfixe"
        />
        <meta
          property="og:description"
          content="Stop wasting your Google Ads budget on keywords you can't afford. Upfixe filters keywords by your budget, prioritises by volume, and groups them thematically."
        />
        <link rel="canonical" href="https://upfixe.com/keyword-optimisation" />
      </Helmet>
      <FAQSchema items={faqItems} />

      <Header />

      <main className="flex-grow">
        <KOHeroSection />
        <KOProblemSection />
        <KOBudgetAnalysis />
        <KOAffordabilityFilter />
        <KOVolumeSorting />
        <KOThematicGrouping />
        <KOCampaignReady />
        <KOResultsSection />
        <KOComparisonSection />
        <KOFAQSection />
        <KOFinalCTA />
      </main>

      <Footer />
    </div>
  );
};

export default KeywordOptimisation;
